import { createContext } from "react";
import openSocket from "socket.io-client";
import { getSocketConnectionConfig } from "../../services/backendUrl";

const createNoopSocket = () => ({
  connected: false,
  on: () => {},
  off: () => {},
  emit: () => {},
  disconnect: () => {}
});

const socketManager = {
  currentSocket: null,
  currentToken: null,

  GetSocket: function () {
    const publicToken = localStorage.getItem("public-token") || localStorage.getItem("token");

    if (!publicToken) {
      if (this.currentSocket && typeof this.currentSocket.disconnect === "function") {
        this.currentSocket.disconnect();
      }

      this.currentSocket = null;
      this.currentToken = null;
      return createNoopSocket();
    }

    if (publicToken !== this.currentToken) {
      if (this.currentSocket && typeof this.currentSocket.disconnect === "function") {
        this.currentSocket.disconnect();
      }

      this.currentToken = publicToken;
      const { socketUrl, socketPath } = getSocketConnectionConfig();

      this.currentSocket = openSocket(socketUrl, {
        transports: ["polling"],
        upgrade: false,
        pingTimeout: 18000,
        pingInterval: 18000,
        reconnectionAttempts: 2,
        reconnectionDelay: 3000,
        path: socketPath,
        query: publicToken ? { token: publicToken } : {}
      });
    }

    return this.currentSocket || createNoopSocket();
  },

  onConnect: function (callbackConnect) {
    const socket = this.GetSocket();

    if (socket && socket.connected) {
      callbackConnect();
    }

    socket.on("connect", callbackConnect);
  }
};

const SocketContext = createContext();

export { SocketContext, socketManager };
